import React from 'react';
import EngagementBarLayout from 'app/components/post/EngagementBarLayout';
import BookmarkButton from 'app/components/post/BookmarkButton';
import Reactions from 'app/components/post/Reactions';

import { generateOpinionLink } from 'app/utils/generateShareLink';
import { Dropdown, Button } from 'app/seedly-component-library';
import { MessageCircle, Share2 as Share } from 'react-feather';
import useIsMobile from 'app/utils/hooks/useIsMobile';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import { UPVOTER_TYPE, SAVE_TYPE } from 'app/constants/app';
import useShareMenu from 'app/utils/hooks/useShareMenu';
import { Opinion } from 'app/entity/opinion/opinionTypes';

const EngagementBar = (props: {
  opinion: Opinion;
  onCommentClick: () => void;
}) => {
  const { opinion, onCommentClick = () => {} } = props;

  const {
    id,
    post,
    slug,
    commentsCount,
    createdByCurrentUser,
    pageviewsCount,
  } = opinion;

  const shareUrl = generateOpinionLink(slug);
  const shareMenu = useShareMenu(shareUrl);
  const isMobile = useIsMobile();

  return (
    <EngagementBarLayout
      viewCount={pageviewsCount}
      commentsCount={commentsCount}
      commentButton={
        <Button icon={<MessageCircle />} onClick={onCommentClick} />
      }
      shareButton={
        <Dropdown
          items={shareMenu}
          handleSelectedItemchange={item => {
            item.selectedItem.onClick();
          }}
          menuAlign={isMobile ? 'top' : 'right'}
          button={
            <Button
              size="md"
              variant="ghost"
              data-testid="button-share-options"
              onClick={() => {
                mixpanel.track(trackedEvents.CommentThread, {
                  param: 'share',
                  category: 'opinion',
                });
              }}
              icon={<Share />}
            />
          }
        />
      }
      bookmarkButton={
        <BookmarkButton
          isOwnContent={createdByCurrentUser}
          upvoted={post.upvoted}
          contentId={id}
          saved={post.bookmarked}
          onClickTrack={() => {
            mixpanel.track(trackedEvents.CommentThread, {
              param: 'bookmark',
              category: 'opinion',
            });
          }}
          type={SAVE_TYPE.OPINION}
        />
      }
      reactionButton={
        <Reactions
          id={id}
          type={UPVOTER_TYPE.OPINION}
          upvoteCount={post.upvotesCount}
          upvoted={post.upvoted}
        />
      }
    />
  );
};

export default EngagementBar;
